// extracted by mini-css-extract-plugin
export default {"wrapper":"_p-z","reviewFormSuccess":"aq-z","header":"bq-z","message":"cq-z","paragraph":"dq-z","lottieContainer":"eq-z"};